module.exports = __webpack_public_path__ + "media/images/gift_plan/result-success-2bde4f7471e138619cbc39dd7c46be1e.png";